import { apiEndPoints } from "../../ApiServices/config";
import { getApi, postApi } from "../../ApiServices/api";
import { useState } from "react";
import { toast } from "react-hot-toast";
import { useNavigate } from "react-router-dom";
import { Country, State, City } from "country-state-city";

function useLoadProfileData(){
    const devoteeData = JSON.parse(localStorage.getItem("devoteeData"));
    const navigate = useNavigate();
    const [spouserashi, setSpouseRashi] = useState();
    const [childrenrashi, setChildrenRashi] = useState([]);
    const [spousechildnakshatra, setspouseNakshatra] = useState();
    const [childnakshatra, setchildNakshatra] = useState([]);
    const [childIndex, setChildIndex] = useState(0);
    const [spouseAccordionExpand, setSpouseAccordionExpand] = useState(false);
    const [childrenAccordionExpand, setChildrenAccordionExpand] = useState(false);
    const [countryList,setCountryList] = useState([]);
    const [stateList,setStateList] = useState([]);
    const [cityList,setCityList] = useState([]);
    
    const [masterData, setMasterData] = useState({
        languageData: null,
        nakshatraData: null,
        rashiData: null,
        userData: null,
    });

    const getMasterData = async () => {
        console.log("helo");
        
        const payload = {
          country_id: "611ce96de2cd656171314e2a",
          rashi_id: "611ce9cde2cd656171314e4f",
        };
        const result = await Promise.all([
          getApi(apiEndPoints.languages),
          getApi(apiEndPoints.nakshatram),
          getApi(apiEndPoints.rashi),
          postApi(apiEndPoints.getProfile, {
            user_id: devoteeData.user_id,
          }),
        ]);
    
        setchildNakshatra((prev) => {
          const updatedChildrenNakshatra = [...prev];
          updatedChildrenNakshatra[childIndex] = result[1]?.data?.data;
          return updatedChildrenNakshatra;
        });
        setChildrenRashi((prev) => {
          const updatedChildrenRashi = [...prev];
          updatedChildrenRashi[childIndex] = result[2]?.data?.data;
          return updatedChildrenRashi;
        });
    
        setspouseNakshatra((childnakshatra[0] = result[1]?.data?.data));
        setSpouseRashi(result[2]?.data?.data);
        setMasterData({
          languageData: result[0]?.data?.data,
          nakshatraData: result[1]?.data?.data,
          rashiData: result[2]?.data?.data,
          userData: result[3]?.data?.data,
        });
      };

      const getCountryData = ()=>{
          const countries = Country.getAllCountries();
          console.log("countries: ",countries);    
          console.log("masterData?.userData?.address?.country: ",masterData?.userData?.address?.country);
          setCountryList(countries);
          const states = State.getStatesOfCountry(masterData?.userData?.address?.country);
          setStateList(states);
          console.log("states : ",states);          
          const cities = City.getCitiesOfState(
            masterData?.userData?.address?.country,
            masterData?.userData?.address?.state
          );
          console.log("cities: ",cities);          
          setCityList(cities);
        }
      
      const handleCountryChange = (countryCode) => {
        const states = State.getStatesOfCountry(countryCode);
        setStateList(states);
        setCityList([]);
      };
        
      const handleStateChange = (stateCode, countryCode) => {
        const cities = City.getCitiesOfState(countryCode, stateCode);
        setCityList(cities);
      };
      

      const prefillChilderanoptions = async (masterData) => {
          const result = await Promise.all([
            getApi(apiEndPoints.nakshatram),
            getApi(apiEndPoints.rashi),
          ]);
          masterData?.userData?.childrens.map((item, index) => {
            setchildNakshatra((prev) => {
              const updatedChildrenNakshatra = [...prev];
              updatedChildrenNakshatra[index] = result[0]?.data?.data;
              return updatedChildrenNakshatra;
            });
            setChildrenRashi((prev) => {
              const updatedChildrenRashi = [...prev];
              updatedChildrenRashi[index] = result[1]?.data?.data;
              return updatedChildrenRashi;
            });
          });
        };

        const onSubmit = async (data) => {
            if (!childrenAccordionExpand) {
                data.childrens = null;
            }
        
            if (!spouseAccordionExpand) {
                data.spouse = null;
            }
            data.user_id = JSON.parse(localStorage.getItem("devoteeData"))?.user_id;
            try {
                const response = await postApi(apiEndPoints.devoteeUpdate, data);
                if (response?.data?.status === 0) {
                toast.error(response?.data?.message);
                } else if (response?.data?.status === 1) {
                toast.success(response?.data?.message);
                localStorage.setItem(
                    "devoteeData",
                    JSON.stringify(response?.data?.data)
                );
                navigate("/profile");
                }
            } catch (error) {
                toast.error(`Registration failed: , ${error}`);
            }
        };
        
    return {
        devoteeData,
        getMasterData,
        masterData,
        spousechildnakshatra,
        childnakshatra,
        spouserashi,
        childrenrashi,
        prefillChilderanoptions,
        onSubmit,
        navigate,
        spouseAccordionExpand,
        setSpouseAccordionExpand,
        childrenAccordionExpand,
        setChildrenAccordionExpand,
        childIndex,
        setChildIndex,
        setMasterData,
        getCountryData,
        countryList,
        stateList,
        cityList,
        handleCountryChange,
        handleStateChange
    }
}
export default useLoadProfileData;